/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { CreateVaultCategoryRequest } from '../models/CreateVaultCategoryRequest';
import type { DeleteVaultMediasRequest } from '../models/DeleteVaultMediasRequest';
import type { ListVaultCategoriesResponse } from '../models/ListVaultCategoriesResponse';
import type { ListVaultCategoryRequest } from '../models/ListVaultCategoryRequest';
import type { MoveMediaRequest } from '../models/MoveMediaRequest';
import type { RenameVaultCategorySchema } from '../models/RenameVaultCategorySchema';
import type { SearchVaultMediaRequest } from '../models/SearchVaultMediaRequest';
import type { SearchVaultMediaResponse } from '../models/SearchVaultMediaResponse';
import type { SortCustomVaultCategoryRequest } from '../models/SortCustomVaultCategoryRequest';
import type { SortVaultCategoryRequest } from '../models/SortVaultCategoryRequest';
import type { SortVaultCategoryResponse } from '../models/SortVaultCategoryResponse';
import type { VaultCategory } from '../models/VaultCategory';
import type { VaultMediaResponseDto } from '../models/VaultMediaResponseDto';
import type { VaultMediaSignatureResponse } from '../models/VaultMediaSignatureResponse';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class VaultService {
    /**
     * Search vault media
     * This endpoint allows you to search for media in the vault
     * @returns SearchVaultMediaResponse OK
     * @throws ApiError
     */
    public static search({
        creatorId,
        requestBody,
    }: {
        /**
         * The creator id
         */
        creatorId: number,
        /**
         * The search text
         */
        requestBody: SearchVaultMediaRequest,
    }): CancelablePromise<SearchVaultMediaResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/dashboard/api/v1/creator/vault/{creatorId}/search',
            path: {
                'creatorId': creatorId,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * Retrieve media
     * This endpoint allows you to retrieve a media
     * @returns any The media
     * @throws ApiError
     */
    public static retrieveMedia({
        creatorId,
        mediaId,
    }: {
        /**
         * The creator id
         */
        creatorId: number,
        /**
         * The media id
         */
        mediaId: number,
    }): CancelablePromise<Record<string, any>> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/dashboard/api/v1/creator/vault/{creatorId}/media/{mediaId}',
            path: {
                'creatorId': creatorId,
                'mediaId': mediaId,
            },
            errors: {
                403: `No permission for this feature for this creator or creator has no access to this feature.`,
                409: `When the creator has not enabled the vault feature`,
                502: `When the OnlyFans API has an error`,
            },
        });
    }
    /**
     * List all vault categories
     * This endpoint allows you to list the categories in the vault
     * @returns ListVaultCategoriesResponse Successfully the list of categories
     * @throws ApiError
     */
    public static listCategories({
        creatorId,
        requestBody,
    }: {
        /**
         * The creator id
         */
        creatorId: number,
        /**
         * The given filter for list all vault categories
         */
        requestBody: ListVaultCategoryRequest,
    }): CancelablePromise<ListVaultCategoriesResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/dashboard/api/v1/creator/vault/{creatorId}/category',
            path: {
                'creatorId': creatorId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                403: `No permission for this feature for this creator or creator has no access to this feature.`,
                409: `When the creator has not enabled the vault feature`,
                502: `When the OnlyFans API has an error`,
            },
        });
    }
    /**
     * @returns SortVaultCategoryResponse OK
     * @throws ApiError
     */
    public static getVaultSorting({
        creatorId,
    }: {
        creatorId: number,
    }): CancelablePromise<SortVaultCategoryResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/dashboard/api/v1/creator/vault/{creatorId}/category/sort',
            path: {
                'creatorId': creatorId,
            },
        });
    }
    /**
     * Sort the vault category
     * This endpoint allows you to sort the category - IMPORTANT: This changes happens for all users
     * @returns any Successfully sorted the vault categories
     * @throws ApiError
     */
    public static sortCategory({
        creatorId,
        requestBody,
    }: {
        /**
         * The creator id
         */
        creatorId: number,
        /**
         * The given sorting filters
         */
        requestBody: SortVaultCategoryRequest,
    }): CancelablePromise<Record<string, any>> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/dashboard/api/v1/creator/vault/{creatorId}/category/sort',
            path: {
                'creatorId': creatorId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                403: `No permission for this feature for this creator or creator has no access to this feature.`,
                409: `When the creator has not enabled the vault feature`,
                502: `When the OnlyFans API has an error`,
            },
        });
    }
    /**
     * Sort the vault category with custom order
     * This endpoint allows you to sort the category - IMPORTANT: This changes happens for all users
     * @returns any Successfully sorted the vault categories
     * @throws ApiError
     */
    public static sortCategoryCustom({
        creatorId,
        requestBody,
    }: {
        /**
         * The creator id
         */
        creatorId: number,
        /**
         * The sorting
         */
        requestBody: SortCustomVaultCategoryRequest,
    }): CancelablePromise<Record<string, any>> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/dashboard/api/v1/creator/vault/{creatorId}/category/sort/custom',
            path: {
                'creatorId': creatorId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                403: `No permission for this feature for this creator or creator has no access to this feature.`,
                409: `When the creator has not enabled the vault feature`,
                502: `When the OnlyFans API has an error`,
            },
        });
    }
    /**
     * Move medias to a category
     * This endpoint allows you to move medias to a category
     * @returns VaultCategory Successfully moved the medias
     * @throws ApiError
     */
    public static moveMedias({
        creatorId,
        requestBody,
    }: {
        /**
         * The creator id
         */
        creatorId: number,
        /**
         * The given medias
         */
        requestBody: MoveMediaRequest,
    }): CancelablePromise<VaultCategory> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/dashboard/api/v1/creator/vault/{creatorId}/category/medias',
            path: {
                'creatorId': creatorId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                403: `No permission for this feature for this creator or creator has no access to this feature.`,
                409: `When the creator has not enabled the vault feature`,
                500: `When the OnlyFans API has an error`,
            },
        });
    }
    /**
     * Delete medias from a category
     * This endpoint allows you to delete medias from a category
     * @returns VaultCategory Successfully delete the medias
     * @throws ApiError
     */
    public static deleteMedias({
        creatorId,
        categoryId,
        mediaIds,
    }: {
        /**
         * The creator id
         */
        creatorId: number,
        /**
         * The category id
         */
        categoryId: number,
        /**
         * The media ids
         */
        mediaIds: Array<number>,
    }): CancelablePromise<VaultCategory> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/dashboard/api/v1/creator/vault/{creatorId}/category/medias',
            path: {
                'creatorId': creatorId,
            },
            query: {
                'categoryId': categoryId,
                'mediaIds': mediaIds,
            },
            errors: {
                403: `No permission for this feature for this creator or creator has no access to this feature.`,
                409: `When the creator has not enabled the vault feature`,
                500: `When the OnlyFans API has an error`,
            },
        });
    }
    /**
     * Create vault category
     * This endpoint allows you to create a category in the vault
     * @returns any Successfully created the vault category
     * @throws ApiError
     */
    public static createCategory({
        creatorId,
        requestBody,
    }: {
        /**
         * The creator id
         */
        creatorId: number,
        /**
         * The given name
         */
        requestBody: CreateVaultCategoryRequest,
    }): CancelablePromise<Record<string, any>> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/dashboard/api/v1/creator/vault/{creatorId}/category/create',
            path: {
                'creatorId': creatorId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                403: `No permission for this feature for this creator or creator has no access to this feature.`,
                409: `When the creator has not enabled the vault feature`,
                502: `When the OnlyFans API has an error`,
            },
        });
    }
    /**
     * Get category
     * Get category for the given creator
     * @returns VaultCategory OK
     * @throws ApiError
     */
    public static getCategory({
        creatorId,
        categoryId,
    }: {
        /**
         * The ID of the creator
         */
        creatorId: number,
        /**
         * The ID of the category
         */
        categoryId: number,
    }): CancelablePromise<VaultCategory> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/dashboard/api/v1/creator/vault/{creatorId}/category/{categoryId}',
            path: {
                'creatorId': creatorId,
                'categoryId': categoryId,
            },
        });
    }
    /**
     * Rename a vault category
     * This endpoint allows you to list the categories in the vault
     * @returns any Successfully renamed the category
     * @throws ApiError
     */
    public static renameCategory({
        creatorId,
        categoryId,
        requestBody,
    }: {
        /**
         * The creator id
         */
        creatorId: number,
        /**
         * The onlyfans id from the category
         */
        categoryId: number,
        /**
         * The new name of the category
         */
        requestBody: RenameVaultCategorySchema,
    }): CancelablePromise<Record<string, any>> {
        return __request(OpenAPI, {
            method: 'PATCH',
            url: '/dashboard/api/v1/creator/vault/{creatorId}/category/{categoryId}',
            path: {
                'creatorId': creatorId,
                'categoryId': categoryId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                403: `No permission for this feature for this creator or creator has no access to this feature.`,
                409: `When the creator has not enabled the vault feature`,
                502: `When the OnlyFans API has an error`,
            },
        });
    }
    /**
     * Download file content by CreatorHero CDN URL and asynchronously clone it to our S3 if not present yet.
     * To download content original OnlyFans URL is used internally.
     *
     * @returns binary File content
     * @throws ApiError
     */
    public static downloadFileV3({
        chUrl,
        creatorId,
    }: {
        /**
         * CreatorHero CDN URL (without signature params)
         */
        chUrl: string,
        creatorId: number,
    }): CancelablePromise<Blob> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/dashboard/api/v3/creator/vault/{creatorId}/media-download',
            path: {
                'creatorId': creatorId,
            },
            query: {
                'chUrl': chUrl,
            },
            errors: {
                403: `Forbidden. The user does not have permission to access this resource.`,
            },
        });
    }
    /**
     * List vault medias
     * This endpoint allows you to retrieve the Creator's Vault media.
     * @returns VaultMediaResponseDto The vault medias
     * @throws ApiError
     */
    public static getVaultMedias({
        creatorId,
        limit,
        offset,
        field,
        sort,
        list,
        type,
        beforePublishDate,
    }: {
        /**
         * The creator id
         */
        creatorId: number,
        limit?: number,
        offset?: number,
        field?: string,
        sort?: string,
        list?: string,
        type?: string,
        /**
         * You can sort by before published date
         */
        beforePublishDate?: string,
    }): CancelablePromise<VaultMediaResponseDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/dashboard/api/v2/creator/vault/{creatorId}',
            path: {
                'creatorId': creatorId,
            },
            query: {
                'limit': limit,
                'offset': offset,
                'field': field,
                'sort': sort,
                'list': list,
                'type': type,
                'beforePublishDate': beforePublishDate,
            },
            errors: {
                403: `No permission for this feature for this creator or creator has no access to this feature.`,
                409: `When the creator has not enabled the vault feature`,
                502: `When the OnlyFans API has an error`,
            },
        });
    }
    /**
     * Stream vault media
     * This endpoint allows you to stream media from the vault using a signed token
     * @returns any Stream started successfully
     * @throws ApiError
     */
    public static streamV2({
        signToken,
    }: {
        /**
         * The signed token that authorizes the stream
         */
        signToken: string,
    }): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/dashboard/api/v2/creator/vault/stream/{signToken}',
            path: {
                'signToken': signToken,
            },
            errors: {
                403: `No permission for the action`,
                404: `Not found. Possible reason: browserProfile, signature or signed URL not found `,
                502: `When the OnlyFans API has an error while streaming media`,
            },
        });
    }
    /**
     * Create a signature for a stream
     * This endpoint allows you to create a signature for a stream
     * @returns VaultMediaSignatureResponse OK
     * @throws ApiError
     */
    public static createSignature({
        creatorId,
        mediaId,
    }: {
        /**
         * The creator id
         */
        creatorId: number,
        mediaId: number,
    }): CancelablePromise<VaultMediaSignatureResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/dashboard/api/v1/creator/vault/{creatorId}/stream-signature',
            path: {
                'creatorId': creatorId,
            },
            query: {
                'mediaId': mediaId,
            },
        });
    }
    /**
     * Delete vault media
     * If you want to explicitly remove media from the vault, it also allows you to specify multiple media.
     * @returns any Successfully deleted the vault media
     * @throws ApiError
     */
    public static deleteMedia({
        creatorId,
        requestBody,
    }: {
        /**
         * The creator id
         */
        creatorId: number,
        /**
         * The given media ids
         */
        requestBody: DeleteVaultMediasRequest,
    }): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/dashboard/api/v1/creator/vault/{creatorId}',
            path: {
                'creatorId': creatorId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                403: `No permission for this feature for this creator or creator has no access to this feature.`,
                409: `When the creator has not enabled the vault feature`,
                502: `When the OnlyFans API has an error`,
            },
        });
    }
    /**
     * Delete vault category
     * This endpoint allows you to delete a category in the vault
     * @returns any Successfully deleted the vault category
     * @throws ApiError
     */
    public static deleteCategory({
        creatorId,
        categoryId,
        clearMedia,
    }: {
        /**
         * The creator id
         */
        creatorId: number,
        /**
         * The category id
         */
        categoryId: number,
        /**
         * Should clear media
         */
        clearMedia: boolean,
    }): CancelablePromise<Record<string, any>> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/dashboard/api/v1/creator/vault/{creatorId}/category/{categoryId}/{clearMedia}',
            path: {
                'creatorId': creatorId,
                'categoryId': categoryId,
                'clearMedia': clearMedia,
            },
            errors: {
                403: `No permission for this feature for this creator or creator has no access to this feature.`,
                409: `When the creator has not enabled the vault feature`,
                502: `When the OnlyFans API has an error`,
            },
        });
    }
}
